// ── Service de pipeline_members (núcleo/aplicação) ────────────────
// Filtro/ordenação e validações. I/O via porta.

import type {
  IPipelineMembersRepository,
  PipelineMemberEntry,
  PipelineMemberProfile,
  ListPipelineMembersOpts,
  UpsertPipelineMemberParams,
} from '../ports/IPipelineMembersRepository';

export class PipelineMembersService {
  constructor(private readonly repo: IPipelineMembersRepository) {}

  listPipelineMembers = async (
    pipelineId: string | null | undefined,
    opts: ListPipelineMembersOpts = {},
  ): Promise<PipelineMemberEntry[]> => {
    if (!pipelineId) return [];
    const rows = await this.repo.fetchPipelineMembers(pipelineId, opts);
    return rows
      .filter(m => m.profile && m.profile.ativo !== false)
      .sort((a, b) => (a.profile?.nome || '').localeCompare(b.profile?.nome || ''));
  };

  listProfilesByPipelineRole = async (
    pipelineId: string,
    role: 'sdr' | 'closer',
  ): Promise<PipelineMemberProfile[]> => {
    const members = await this.listPipelineMembers(pipelineId, { role, onlyActive: true });
    return members.map(m => m.profile).filter((p): p is PipelineMemberProfile => !!p);
  };

  upsertPipelineMember = async (params: UpsertPipelineMemberParams): Promise<PipelineMemberEntry> => {
    const { workspaceId, pipelineId, profileId, role } = params;
    if (!workspaceId || !pipelineId || !profileId || !role) {
      throw new Error('workspace_id, pipeline_id, profile_id e role são obrigatórios.');
    }
    return this.repo.upsertPipelineMember(params);
  };

  setPipelineMemberActive = async (id: string, ativo: boolean): Promise<void> => {
    if (!id) throw new Error('id obrigatório.');
    return this.repo.setPipelineMemberActive(id, !!ativo);
  };

  deletePipelineMember = async (id: string): Promise<void> => {
    if (!id) throw new Error('id obrigatório.');
    return this.repo.deletePipelineMember(id);
  };
}
